export default "__VITE_ASSET__BKoGBykD__"